// This function will return the hostname of the production server
// based on the current hostname of the window.
const { getBaseDomainFromHostname } = require('../../utils/domainUtil');
const DEV_IMAGE_DOMAINS = ['88named.com', 'namedhub.com', '1named.com'];

const getDevImageDomain = (domain) =>
  DEV_IMAGE_DOMAINS.includes(domain) ? 'nmd.co' : domain;

const getProductionHostname = () => {
  if (typeof window !== 'undefined' && window.location) {
    const hostname = window.location.hostname

    if (hostname === 'm.docker.named.com') return 'named.net';

    if (hostname === 'localhost') return 'named.com';

    return getBaseDomainFromHostname(hostname, 'nmd.co');
  }

  return 'nmd.co'
}

const getUrl = () => {
  const env = process.env.REACT_APP_API;
  const prodHostName = getProductionHostname();
  const devImageDomain = getDevImageDomain(prodHostName);

  // const env = "production";

  let sports = 'http://172.16.20.93:8090/v1.0'
  let named = 'http://beta.challenger-api.nmd.co/'
  let namedChallenger = 'https://challenger-api.nmd.co/'
  let namedApi = 'https://nmd.co/'
  let thumb = `https://thumb.${prodHostName}/`
  let s3Endpoint = 'https://s3.ap-northeast-2.amazonaws.com'
  let s3Bucket = 'data.score.named.com-new'
  let legacySports = 'http://172.16.20.93:8092/named/v1'
  let webSocket = 'ws://172.16.20.96:8880/sub'
  let sportsWebURL = 'http://dev.score.nmd.co/'
  let casterWebURL = 'http://dev.caster.nmd.co/'
  let legacyApiKey = 'vYXBNAxjFCre'
  let dataThumbUrl = thumb + 'normal/resize/origin'
  let jsonPath = '/data'
  let namedWeb = 'https://nmd.co/'
  let hostNamedWeb = 'nmd.co'
  let imageNamed = 'https://image.nmd.co/'

  let champ = 'https://arowana-api.champscore.com/'
  let champThumb = 'https://thumb.champscore.com'
  let champWebSocket = 'wss://push.champscore.com/sub'
  let contactUsLink = `https://sports.${prodHostName}/contact-us`

  switch (env) {
    case 'development':
      sports = 'http://43.202.207.115:8090/v1.0'
      webSocket = 'ws://43.202.207.115:8880/sub'
      named = `http://dev.challenger-api.${prodHostName}/`
      namedChallenger = `http://dev.challenger-api.${prodHostName}/`
      namedApi = `http://dev.${prodHostName}/`
      thumb = 'http://43.202.207.115:22010/'
      s3Endpoint = 'https://s3.ap-northeast-2.amazonaws.com'
      s3Bucket = 'test.score.named.com-new'
      legacySports = 'http://43.202.207.115:8092/named/v1'
      sportsWebURL = `http://dev.score.${prodHostName}/`
      casterWebURL = `http://dev.caster.${prodHostName}/`
      legacyApiKey = 'vYXBNAxjFCre'
      namedWeb = `http://dev.${prodHostName}/`

      hostNamedWeb = `dev.${prodHostName}`
      imageNamed = `https://image.${devImageDomain}/`

      //  TODO 챔프스코어 세팅 후 변경
      champ = 'http://mschoo.arowana-api.fishtank.com/';
      champThumb = 'http://dev-thumb.champscore.com';
      champWebSocket = 'ws://172.16.20.103:8880/sub';

      contactUsLink = `http://dev-sports.${prodHostName}/contact-us`;
      break;

    case 'beta':
      sports = 'http://172.16.20.163:8080/v1.0'
      named = `http://beta.challenger-api.${prodHostName}/`
      namedChallenger = `https://challenger-api.${prodHostName}/`
      namedApi = `https://${prodHostName}/`
      thumb = `http://thumb.${prodHostName}/`
      s3Endpoint = 'https://s3.ap-northeast-2.amazonaws.com'
      s3Bucket = 'test.score.named.com-new'
      legacySports = 'http://172.16.20.164:8092/named/v1'
      webSocket = 'ws://172.16.20.166:8880/sub'
      sportsWebURL = `http://beta.score.${prodHostName}/`
      casterWebURL = `http://beta.caster.${prodHostName}/`
      legacyApiKey = '8HNjAFFfmQoJ'
      champ = 'http://mschoo.arowana-api.fishtank.com/'
      champThumb = 'http://dev-thumb.champscore.com'
      champWebSocket = 'ws://172.16.20.103:8880/sub'
      contactUsLink = `https://sports.${prodHostName}/contact-us`
      break

    case 'production':
      sports = `https://sports-api.${prodHostName}/v1.0`
      webSocket = `wss://push.${prodHostName}/sub`
      named = `https://challenger-api.${prodHostName}/`
      namedChallenger = `https://challenger-api.${prodHostName}/`
      namedApi = `https://${prodHostName}/`
      thumb = `https://thumb.${prodHostName}/`
      s3Endpoint = 'https://s3.ap-northeast-2.amazonaws.com'
      s3Bucket = 'data.score.named.com-new'
      legacySports = `https://score-api.${prodHostName}/named/v1`
      sportsWebURL = `https://score.${prodHostName}/`
      casterWebURL = `https://sports-caster.${prodHostName}/`
      legacyApiKey = '1rar2zCZvKjp'
      jsonPath = '/data'

      namedWeb = `https://${prodHostName}/`
      hostNamedWeb = `${prodHostName}`
      imageNamed = `https://image.${prodHostName}/`
      contactUsLink = `https://sports.${prodHostName}/contact-us`
      break

    default:
      break
  }

  return {
    sports,
    named,
    namedChallenger,
    namedApi,
    legacySports,
    thumb,
    s3Endpoint,
    s3Bucket,
    webSocket,
    sportsWebURL,
    casterWebURL,
    legacyApiKey,
    dataThumbUrl,
    dataJsonUrl: jsonPath,
    champ,
    champThumb,
    champWebSocket,
    namedWeb,
    hostNamedWeb,
    imageNamed,
    env,
    contactUsLink,
  };
};

const getConstants = () => {
  const _GOOGLE_SITEKEY = '6LdpQMwrAAAAADV8UqDuAiqVrKYZqsyHPWJSr-9_'
  const _GOOGLE_CAPTCHA_INVISIBLE_SITEKEY = '6LeaQMwrAAAAAJ_cgl9gW9F4f_r9ZJlQZtMr7WLL';

  return {
    _GOOGLE_CAPTCHA_INVISIBLE_SITEKEY,
    _GOOGLE_SITEKEY,
  }
}

const Url = getUrl()
const Constants = getConstants()

module.exports = { Url, Constants }